import React, { useEffect, useState } from "react";
import firebase from "../../config/firebase";
import { CircularProgress } from "@material-ui/core";

const Modal = ({ isOpen, dataForModal, onClose, firmId, selectedGraph }) => {
  const [poData, setPOData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [filteredAmount, setFilteredAmount] = useState(0);
  const [totalPO, setTotalPO] = useState(0);

  const getRemainingPo = (id) => {
    let idToSend = [];

    if (selectedGraph === "Daily") {
      idToSend = [id, id];
    } else {
      let dateArray = dataForModal.date.split("-");
      idToSend[0] = new Date(
        dateArray[0].split("/")[1] +
          "/" +
          dateArray[0].split("/")[0] +
          "/" +
          dateArray[0].split("/")[2]
      ).getTime();
      idToSend[1] = new Date(
        dateArray[1].split("/")[1] +
          "/" +
          dateArray[1].split("/")[0] +
          "/" +
          dateArray[1].split("/")[2]
      ).getTime();
    }

    firebase
      .database()
      .ref("poInformation/" + firmId + "/poHistory/")
      .orderByKey()
      .startAt(String(idToSend[0]))
      .endAt(String(idToSend[1]))
      .on("value", (snapshot) => {
        if (snapshot.exists()) {
          let data = Object.values(snapshot.val());
          let array = [];
          for (let index = 0; index < data.length; index++) {
            array = array.concat(Object.values(data[index]));
          }
          setPOData(array);
          setLoading(false);
        } else {
          console.log("No data found here for the PO history");
          setLoading(false);
        }
      });
  };

  const calculateTotalValue = () => {
    const filteredData = poData.filter((item) =>
      item?.projectName?.toLowerCase().includes(query.toLowerCase())
    );
    return filteredData.reduce((sum, item) => sum + item.value, 0);
  };

  const calculateTotalPo = () => {
    const filteredData = poData.filter((item) =>
      item?.projectName?.toLowerCase().includes(query.toLowerCase())
    );
    return filteredData.length;
  };

  useEffect(() => {
    setFilteredAmount(calculateTotalValue());
    setTotalPO(calculateTotalPo());
  }, [query, poData]);

  useEffect(() => {
    if (dataForModal && dataForModal.date && isOpen) {
      setLoading(true);
      getRemainingPo(dataForModal.id);
    }
  }, [dataForModal, selectedGraph, isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    setQuery("");
    onClose();
  };

  // Filter data based on search query
  const filteredData = poData.filter((item) =>
    item?.projectName?.toLowerCase().includes(query.toLowerCase())
  );

  const formatCurrency = (value) => {
    return "₹ " + (value || 0).toLocaleString("en-IN");
  };

  // Modal overlay styles
  const overlayStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 1000
  };

  // Modal content styles
  const contentStyles = {
    width: "400px",
    height: "100%",
    background: "#FFFFFF",
    padding: "30px",
    boxShadow: "-3px 0 20px rgba(0, 0, 0, 0.1)",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column"
  };

  // Header styles
  const headerStyles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "1px solid #E5E5E5"
  };

  const titleStyles = {
    fontFamily: "'Montserrat', sans-serif",
    fontSize: "18px",
    fontWeight: 600,
    color: "#333333",
    margin: 0
  };

  const closeButtonStyles = {
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
    color: "#777777",
    padding: "5px"
  };

  // Info container styles
  const infoContainerStyles = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "28px"
  };

  const infoItemStyles = {
    display: "flex",
    flexDirection: "column"
  };

  const infoLabelStyles = {
    fontFamily: "'Montserrat', sans-serif",
    fontSize: "13px",
    color: "#777777",
    marginBottom: "6px"
  };

  const infoValueStyles = {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    color: "#333333"
  };

  // Search container styles
  const searchContainerStyles = {
    marginBottom: "24px",
    width: "100%",
    position: "relative"
  };

  const searchInputStyles = {
    width: "100%",
    padding: "12px 16px",
    border: "1px solid #E5E5E5",
    borderRadius: "4px",
    fontSize: "14px",
    color: "#333333",
    backgroundColor: "#F9F9F9",
    outline: "none",
    boxSizing: "border-box"
  };

  // List styles
  const listStyles = {
    listStyle: "none",
    padding: 0,
    margin: 0
  };

  const poItemStyles = {
    padding: "16px 0",
    borderBottom: "1px solid #E5E5E5"
  };

  const poItemHeaderStyles = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px"
  };

  const poItemTitleStyles = {
    fontWeight: 600,
    fontSize: "15px",
    color: "#333333"
  };

  const poItemDetailsStyles = {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "13px",
    color: "#777777"
  };

  // Loading styles
  const loadingContainerStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100% - 120px)"
  };

  const loadingTextStyles = {
    marginTop: "16px",
    fontFamily: "'Montserrat', sans-serif",
    color: "#666666",
    fontSize: "14px"
  };

  const emptyStateStyles = {
    textAlign: "center",
    padding: "48px 0",
    color: "#777777",
    fontSize: "14px"
  };

  return (
    <div style={overlayStyles} onClick={handleClose}>
      <div style={contentStyles} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyles}>
          <h2 style={titleStyles}>Purchase Order Details</h2>
          <button style={closeButtonStyles} onClick={handleClose}>×</button>
        </div>

        {loading ? (
          <div style={loadingContainerStyles}>
            <CircularProgress style={{ color: "#2C3E50" }} />
            <p style={loadingTextStyles}>Loading purchase order data...</p>
          </div>
        ) : (
          <>
            <div style={infoContainerStyles}>
              <div style={infoItemStyles}>
                <span style={infoLabelStyles}>Date</span>
                <span style={infoValueStyles}>{dataForModal?.date}</span>
              </div>
              <div style={infoItemStyles}>
                <span style={infoLabelStyles}>Total POs</span>
                <span style={infoValueStyles}>
                  {query !== "" ? totalPO : dataForModal?.count || 0}
                </span>
              </div>
              <div style={infoItemStyles}>
                <span style={infoLabelStyles}>Total Value</span>
                <span style={infoValueStyles}>
                  {query !== ""
                    ? formatCurrency(filteredAmount)
                    : formatCurrency(dataForModal?.value)}
                </span>
              </div>
            </div>

            <div style={searchContainerStyles}>
              <input
                autoComplete="off"
                type="text"
                placeholder="Search by project name"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                style={searchInputStyles}
              />
            </div>

            {filteredData.length > 0 ? (
              <div style={listStyles}>
                {filteredData.map((item, index) => (
                  <div 
                    key={index} 
                    style={{
                      ...poItemStyles,
                      borderBottom: index === filteredData.length - 1 ? "none" : "1px solid #E5E5E5"
                    }}
                  >
                    <div style={poItemHeaderStyles}>
                      <span style={poItemTitleStyles}>{item.name}</span>
                      <span style={poItemTitleStyles}>
                        {formatCurrency(item.value)}
                      </span>
                    </div>
                    <div style={poItemDetailsStyles}>
                      <span>{item.projectName || "NA (NOT AVAILABLE)"}</span>
                      <span>{item.category}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={emptyStateStyles}>
                No purchase orders found matching your search.
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Modal;